import { Link, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Tabs, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { cn } from "@/lib/utils";

type ImagesSectionTab = "folders" | "gallery" | "map";

function keepRelevantQuery(search: string): string {
  const source = new URLSearchParams(search);
  const next = new URLSearchParams();
  const keys = [
    "panelStructure",
    "brand",
    "folderType",
    "model",
    "color",
    "prelisType",
    "category",
    "dateFrom",
    "dateTo",
    "dateFilter",
    "name",
  ];
  for (const key of keys) {
    source.getAll(key).forEach((v) => next.append(key, v));
  }
  return next.toString();
}

export function ImagesSectionTabs({
  active,
  className,
  tabsListClassName,
  compact = false,
}: {
  active: ImagesSectionTab;
  className?: string;
  /** Pl. `w-full sm:w-auto` – útvonalgenerátor / galéria második sora */
  tabsListClassName?: string;
  compact?: boolean;
}) {
  const { t } = useTranslation();
  const location = useLocation();

  const galleryQuery = keepRelevantQuery(location.search);
  const mapQuery = keepRelevantQuery(location.search);
  const foldersQuery = keepRelevantQuery(location.search);

  const galleryTo = galleryQuery ? `/images/gallery?${galleryQuery}` : "/images/gallery";
  const mapTo = mapQuery ? `/images/maps?${mapQuery}` : "/images/maps";
  const foldersTo = foldersQuery ? `/images/projects?${foldersQuery}` : "/images/projects";

  return (
    <Tabs value={active} className={cn("w-full", className)}>
      <TabsList
        className={cn(
          "inline-flex w-full sm:w-auto",
          compact && "h-8",
          tabsListClassName,
        )}
      >
        <TabsTrigger
          value="gallery"
          asChild
          className={cn("whitespace-nowrap", compact && "px-2 text-xs")}
        >
          <Link to={galleryTo}>{t("images.gallery")}</Link>
        </TabsTrigger>
        <TabsTrigger value="map" asChild className={cn("whitespace-nowrap", compact && "px-2 text-xs")}>
          <Link to={mapTo}>{t("images.viewMap")}</Link>
        </TabsTrigger>
        <TabsTrigger value="folders" asChild className={cn("whitespace-nowrap", compact && "px-2 text-xs")}>
          <Link to={foldersTo}>{t("sidebar.images")}</Link>
        </TabsTrigger>
      </TabsList>
    </Tabs>
  );
}

